import { Col, Menu, Row } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IResourceDetails } from "../../types";

export default function ResourceSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();
    const [activeTab, setActiveTab] = useState("general");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[8] || "general");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                >
                    <Menu.Item key="general">General</Menu.Item>
                    {
                        !resourceDetails.isPublic &&
                        <Menu.Item key="git">Git</Menu.Item>
                    }
                    {
                        resourceDetails.domain.eligibleForDomainConfiguration &&
                        <Menu.Item key="domain">Domain</Menu.Item>
                    }
                    <Menu.Item key="danger-zone" danger>Danger Zone</Menu.Item>
                </Menu>
            </Col>
            <Col span={18}>
                <Outlet context={{ resourceDetails }} />
            </Col>
        </Row >
    )
}